import { Component, inject } from '@angular/core';
import { MethodBase } from '../base/method-base';
import { AuthMethodViewModel, YubikeyAuthMethodViewModel } from '../../../../services/identity';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-method-yubikey',
    templateUrl: './yubikey.component.html',
    styleUrl: './yubikey.component.scss',
    imports: [ReactiveFormsModule, TranslatePipe]
})
export class YubikeyComponent extends MethodBase {
  private fb = inject(FormBuilder);


  private yubikeyMethod: YubikeyAuthMethodViewModel;
  private showSerialNumber: boolean;

  override ngOnInit() {
    super.ngOnInit();
    this.setup();
    this.monitorFormStatus();

  }

    setup(): void {
      this.yubikeyMethod = this.method as YubikeyAuthMethodViewModel;
      this.form = this.fb.group({
        code: [this.yubikeyMethod.code, [Validators.required, Validators.minLength(12)]]
      });
    }
    cancel(): void {
        
    }
    getMethod(): YubikeyAuthMethodViewModel {
      this.yubikeyMethod.code = this.form.value.code;
      return this.yubikeyMethod;
    }

}
